module.exports = __webpack_public_path__ + "img/sample-slide.6700bbcb.jpg";